import { render, staticRenderFns } from "./Projection.vue?vue&type=template&id=22709bca"
import script from "./Projection.vue?vue&type=script&lang=js"
export * from "./Projection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports